import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_goorder_kpi = {
	id: "REPORT_goorder_kpi",
	name: "KPI GoOrder",
	data: [
		{
			id: "TRANSACTION",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=GOORDER¥EMENU",
			groups: ["NONE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt={date_range__MONTH}",
				},
			],
		},
		{
			id: "TRANSACTION_LAST_MONTH",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=GOORDER¥EMENU",
			groups: ["NONE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt={date_range__MONTH¥previous_1_months}",
				},
			],
		},
		{
			id: "TRANSACTION_LAST_YEAR",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=GOORDER¥EMENU",
			groups: ["NONE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt={date_range__MONTH¥previous_12_months}",
				},
			],
		},
	],
	table: [
		{
			id: "locations",
			name: "Lokalizacje",
			rows: [
				{
					id: "location",
					name: "Lokalizacje",
					data_id: "TRANSACTION",
					aggregate_columns: {
						summary:
							"new_quantity + reactivation_quantity + upgrade_quantity + downgrade_quantity + churn_quantity",
						new: "new_quantity",
						reactivation: "reactivation_quantity",
						upgrade: "upgrade_quantity",
						downgrade: "downgrade_quantity",
						churn: "churn_quantity",
					},
					compare: [
						{
							id: "location_last_month",
							data_id: "TRANSACTION_LAST_MONTH",
							name: "vs prev month",
							format: "VALUE",
							aggregate_columns: {
								summary:
									"new_quantity + reactivation_quantity + upgrade_quantity + downgrade_quantity + churn_quantity",
								new: "new_quantity",
								reactivation: "reactivation_quantity",
								upgrade: "upgrade_quantity",
								downgrade: "downgrade_quantity",
								churn: "churn_quantity",
							},
						},
						{
							id: "location_last_q_growth",
							data_id: "TRANSACTION_LAST_MONTH",
							name: "vs prev month %",
							format: "GROWTH",
							aggregate_columns: {
								summary:
									"new_quantity + reactivation_quantity + upgrade_quantity + downgrade_quantity + churn_quantity",
								new: "new_quantity",
								reactivation: "reactivation_quantity",
								upgrade: "upgrade_quantity",
								downgrade: "downgrade_quantity",
								churn: "churn_quantity",
							},
						},
						{
							id: "location_last_year",
							data_id: "TRANSACTION_LAST_YEAR",
							name: "vs Prev Year",
							format: "VALUE",
							aggregate_columns: {
								summary:
									"new_quantity + reactivation_quantity + upgrade_quantity + downgrade_quantity + churn_quantity",
								new: "new_quantity",
								reactivation: "reactivation_quantity",
								upgrade: "upgrade_quantity",
								downgrade: "downgrade_quantity",
								churn: "churn_quantity",
							},
						},
						{
							id: "location_last_year_growth",
							data_id: "TRANSACTION_LAST_YEAR",
							name: "vs Prev Year %",
							format: "GROWTH",
							aggregate_columns: {
								summary:
									"new_quantity + reactivation_quantity + upgrade_quantity + downgrade_quantity + churn_quantity",
								new: "new_quantity",
								reactivation: "reactivation_quantity",
								upgrade: "upgrade_quantity",
								downgrade: "downgrade_quantity",
								churn: "churn_quantity",
							},
						},
					],
				},
			],
			columns: [
				{
					id: "summary",
					data_column_id: "summary",
					name: "Suma",
				},
				{
					id: "new",
					data_column_id: "summary",
					name: "Nowe",
				},
				{
					id: "reactivation",
					data_column_id: "summary",
					name: "Reaktywacje",
				},
				{
					id: "upgrade",
					data_column_id: "summary",
					name: "Upgrade",
				},
				{
					id: "downgrade",
					data_column_id: "summary",
					name: "Downgrade",
				},
				{
					id: "churn",
					data_column_id: "summary",
					name: "Churn",
				},
			],
		},
		// {
		//     id: "MRR",
		//     name: "Mrr",
		//     rows: [
		//         {
		//             id: "location",
		//             name: "Zródło",
		//             data_id: "TRANSACTION",
		//             aggregate: "new_total_price",
		//             group: "COMPANY_SOURCE",
		//             aggregate_columns: {
		//                 new_price: "new_total_price",
		//                 reactivation_price: "reactivation_total_price",
		//                 upgrade_price: "upgrade_total_price",
		//                 downgrade_price: "downgrade_total_price",
		//                 churn_price: "churn_total_price",
		//             },
		//             compare: [
		//                 {
		//                     id: "location_last_q",
		//                     data_id: "TRANSACTION_LAST_Q",
		//                     name: "vs Last Q",
		//                     format: "VALUE",
		//                     aggregate: "new_quantity_customer",
		//                     aggregate_columns: {
		//                         new_price: "new_total_price",
		//                         reactivation_price: "reactivation_total_price",
		//                         upgrade_price: "upgrade_total_price",
		//                         downgrade_price: "downgrade_total_price",
		//                         churn_price: "churn_total_price",
		//                     },
		//                 },
		//                 {
		//                     id: "location_last_q_growth",
		//                     data_id: "TRANSACTION_LAST_Q",
		//                     name: "vs Last Q %",
		//                     format: "GROWTH",
		//                     aggregate: "new_quantity_customer",
		//                     aggregate_columns: {
		//                         new_price: "new_total_price",
		//                         reactivation_price: "reactivation_total_price",
		//                         upgrade_price: "upgrade_total_price",
		//                         downgrade_price: "downgrade_total_price",
		//                         churn_price: "churn_total_price",
		//                     },
		//                 },
		//                 {
		//                     id: "location_last_year",
		//                     data_id: "TRANSACTION_LAST_YEAR",
		//                     name: "vs Last Year",
		//                     format: "VALUE",
		//                     aggregate: "new_quantity_customer",
		//                     aggregate_columns: {
		//                         new_price: "new_total_price",
		//                         reactivation_price: "reactivation_total_price",
		//                         upgrade_price: "upgrade_total_price",
		//                         downgrade_price: "downgrade_total_price",
		//                         churn_price: "churn_total_price",
		//                     },
		//                 },
		//                 {
		//                     id: "location_last_year_growth",
		//                     data_id: "TRANSACTION_LAST_YEAR",
		//                     name: "vs Last Year %",
		//                     format: "GROWTH",
		//                     aggregate: "new_quantity_customer",
		//                     aggregate_columns: {
		//                         new_price: "new_total_price",
		//                         reactivation_price: "reactivation_total_price",
		//                         upgrade_price: "upgrade_total_price",
		//                         downgrade_price: "downgrade_total_price",
		//                         churn_price: "churn_total_price",
		//                     },
		//                 },
		//             ],
		//         }
		//     ],
		//     columns: [
		//         {
		//             id: "new_price",
		//             data_column_id: "summary",
		//             name: "Nowe",
		//         },
		//         {
		//             id: "reactivation_price",
		//             data_column_id: "summary",
		//             name: "Reaktywacje",
		//         },
		//         {
		//             id: "upgrade_price",
		//             data_column_id: "summary",
		//             name: "Upgrade",
		//         },
		//         {
		//             id: "downgrade_price",
		//             data_column_id: "summary",
		//             name: "Downgrade",
		//         },
		//         {
		//             id: "churn_price",
		//             data_column_id: "summary",
		//             name: "Churn",
		//         }
		//     ],
		// }
	],
} as ConfigReportComboApi;
